/**
 * Empresa sem nenhum evento, olhando "desde o inicio": em vez de zeros, a
 * tela ensina a ligar a primeira plataforma.
 *
 * Movido de pages/Dashboard.tsx para o modulo. As URLs sao as que o motor
 * espera em `POST /webhooks/:provider/:companyId`, montadas sobre a origem
 * atual do navegador -- e o endereco do proprio backend que serve o painel.
 */

import { useState } from 'react';
import { EmptyState } from '../../../components/PageState';
import { Button } from '../../../components/ui';

export function PrimeirosPassos({ companyId }: { readonly companyId: string }): JSX.Element {
  const origem = window.location.origin;
  const rotas = [
    { provider: 'Kiwify', url: `${origem}/webhooks/kiwify/${companyId}` },
    { provider: 'Hotmart', url: `${origem}/webhooks/hotmart/${companyId}` },
    { provider: 'Shopify', url: `${origem}/webhooks/shopify/${companyId}` },
  ];
  return (
    <EmptyState
      title="Nenhum carrinho abandonado recebido ainda"
      description={
        <>
          Assim que uma plataforma enviar o primeiro evento de checkout incompleto, ele aparece aqui e entra na fila de 30 minutos. Cadastre a URL de webhook
          da sua plataforma:
        </>
      }
      action={
        <ul className="mt-2 flex w-full max-w-xl flex-col gap-2 text-left">
          {rotas.map((rota) => (
            <li key={rota.provider} className="flex items-center gap-3 rounded-lg border border-line bg-elevated px-3 py-2">
              <span className="w-16 shrink-0 text-xs font-medium text-ink-muted">{rota.provider}</span>
              <code className="min-w-0 flex-1 truncate text-xs text-ink">{rota.url}</code>
              <BotaoCopiar text={rota.url} label={`Copiar URL da ${rota.provider}`} />
            </li>
          ))}
        </ul>
      }
    />
  );
}

function BotaoCopiar({ text, label }: { readonly text: string; readonly label: string }): JSX.Element {
  const [copiado, setCopiado] = useState(false);
  const copiar = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiado(true);
      window.setTimeout(() => setCopiado(false), 1_600);
    } catch {
      // Sem clipboard (http sem TLS, permissao negada): o texto continua visivel.
    }
  };
  return (
    <Button variant="secondary" size="sm" icon={copiado ? 'check' : 'copiar'} aria-label={label} onClick={() => void copiar()} className="shrink-0">
      {copiado ? 'Copiado' : 'Copiar'}
    </Button>
  );
}
